import { createContext, useContext, ReactNode } from 'react';
import { useContentfulData } from '../hooks/useContentfulData';
import { querySiteData } from '../querys/querySiteData';

interface SiteDataContextValue {
    data: any;
    isLoading: boolean;
}

const SiteDataContext = createContext<SiteDataContextValue>({ data: null, isLoading: true });

// Fetches the single combined query once and shares it with every section
// (and the always-mounted Hero/Footer social icons) instead of each one
// firing its own request.
export function SiteDataProvider({ children }: { children: ReactNode }) {
    const { data, isLoading } = useContentfulData(querySiteData);

    return (
        <SiteDataContext.Provider value={{ data, isLoading }}>
            {children}
        </SiteDataContext.Provider>
    );
}

export function useSiteData(): SiteDataContextValue {
    return useContext(SiteDataContext);
}
